/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _switch, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle2, _circle3, _path26, _path27, _circle4, _path28, _path29, _path30, _path31, _path32, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _path33, _path34, _circle11, _circle12, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _circle13, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _circle14, _path96, _circle15, _path97, _path98, _circle16, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _circle17, _circle18, _circle19, _circle20, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _circle21, _circle22, _circle23, _circle24, _circle25, _path268, _path269, _path270, _path271, _path272, _circle26, _circle27, _circle28, _path273, _circle29, _circle30, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _circle31, _circle32, _circle33, _circle34, _circle35, _path287, _path288, _path289, _path290, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301;
const CalendarAddAlt = /*#__PURE__*/React.forwardRef(function CalendarAddAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26 21L23 21 23 18 21 18 21 21 18 21 18 23 21 23 21 26 23 26 23 23 26 23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,30c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S26.4,30,22,30z M22,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S25.3,16,22,16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h6v-2H6V6h4v2h2V6h8v2h2V6h4v6h2V6z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {
  CalendarAddAlt.propTypes = iconPropTypes;
}
const CalendarHeatMap = /*#__PURE__*/React.forwardRef(function CalendarHeatMap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H22V2H20V4H12V2H10V4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,6h4V8h2V6h8V8h2V6h4l0,4H6Zm0,6h5v6H6ZM19,26H13V20h6Zm0-8H13V12h6Zm2,8V20h5l.0012,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CalendarHeatMap.propTypes = iconPropTypes;
}
const CalendarSettings = /*#__PURE__*/React.forwardRef(function CalendarSettings({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H27.91a5.9592,5.9592,0,0,0-1.0244-2.4707L28.364,17.05,26.95,15.6362l-1.4788,1.4785A5.9584,5.9584,0,0,0,23,16.09V14H21v2.09a5.9584,5.9584,0,0,0-2.4709,1.0244L17.05,15.6362,15.636,17.05l1.4787,1.479A5.9618,5.9618,0,0,0,16.09,21H14v2h2.09a5.9618,5.9618,0,0,0,1.0244,2.4707L15.636,26.95,17.05,28.3638l1.4788-1.4785A5.9584,5.9584,0,0,0,21,27.91V30h2V27.91a5.9584,5.9584,0,0,0,2.4709-1.0244L26.95,28.3638,28.364,26.95l-1.4787-1.479A5.9592,5.9592,0,0,0,27.91,23Zm-8,3a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CalendarSettings.propTypes = iconPropTypes;
}
const CalendarTools = /*#__PURE__*/React.forwardRef(function CalendarTools({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.981,24.4333A3.9549,3.9549,0,0,0,26,25a4.0045,4.0045,0,0,0,4-4,3.9427,3.9427,0,0,0-.1492-1.0228l-2.4367,2.4369-.0005-.0005a1.9991,1.9991,0,1,1-2.8272-2.8272l-.0005-.0005,2.4368-2.4368A3.95,3.95,0,0,0,26,17a4.0045,4.0045,0,0,0-4,4,3.9544,3.9544,0,0,0,.5669,2.0191L17,28.586,18.4141,30Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h8V26H6V6h4V8h2V6h8V8h2V6h4v8h2V6A2,2,0,0,0,26,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CalendarTools.propTypes = iconPropTypes;
}
const Calibrate = /*#__PURE__*/React.forwardRef(function Calibrate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.83,21.17,25,17.37l.67-.67a1,1,0,0,0,0-1.41l-6-6a1,1,0,0,0-1.41,0h0l-.79.79L10.71,3.29a1,1,0,0,0-1.41,0h0l-4,4-.12.15-4,6a1,1,0,0,0,.12,1.26l3,3a1,1,0,0,0,1.42,0L10,13.41l2.09,2.09-4.8,4.79a1,1,0,0,0,0,1.41l2,2A1,1,0,0,0,10,24a1,1,0,0,0,.52-.15l4.33-2.6,2.44,2.45a1,1,0,0,0,1.41,0h0l.67-.7,3.79,3.83a4,4,0,0,0,5.66-5.66ZM10,10.58l-5,5L3.29,13.87,6.78,8.63,10,5.41l6.09,6.09L13.5,14.08Zm8,11-2.84-2.84-5,3L9.42,21,19,11.41,23.59,16Zm9.42,3.83a2,2,0,0,1-2.83,0h0l-3.8-3.79,2.83-2.83,3.8,3.79a2,2,0,0,1,0,2.83Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Calibrate.propTypes = iconPropTypes;
}
const Calls = /*#__PURE__*/React.forwardRef(function Calls({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m26,14c1.1028,0,2,.8972,2,2s-.8972,2-2,2-2-.8972-2-2,.8972-2,2-2m0-2c-2.2091,0-4,1.7909-4,4s1.7909,4,4,4,4-1.7909,4-4-1.7909-4-4-4h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m15,11l-1.4143,1.4141,2.5859,2.5859H7.8157c-.4141-1.1611-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8389,2.8157-2h8.356l-2.5859,2.5859,1.4143,1.4141,5-5-5-5Zm-10,6c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Calls.propTypes = iconPropTypes;
}
const CallsAll = /*#__PURE__*/React.forwardRef(function CallsAll({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m26,12c-2.2091,0-4,1.7908-4,4s1.7909,4,4,4,4-1.7909,4-4-1.7908-4-4-4Zm0,6c-1.1028,0-2-.8972-2-2s.8972-2,2-2,2,.8972,2,2-.8972,2-2,2Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m15,21v2h2.5859l-2.3008,2.3008c-.3911-.1875-.8235-.3008-1.2852-.3008-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3c0-.4619-.1135-.894-.3005-1.2852l2.3005-2.3008v2.5859h2v-6h-6Zm-1,8c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m11.4143,11.4141l-1.4143,1.4146,2.1716,2.1714h-4.356c-.4141-1.1611-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8389,2.8157-2h4.356l-2.1716,2.1714,1.4143,1.4146,4.5857-4.5859-4.5857-4.5859Zm-6.4143,5.5859c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m19,5v2.5859l-2.3005-2.3008c.187-.3911.3005-.8232.3005-1.2852,0-1.6543-1.3457-3-3-3s-3,1.3457-3,3,1.3457,3,3,3c.4617,0,.894-.1133,1.2852-.3008l2.3008,2.3008h-2.5859v2h6v-6h-2Zm-6-1c0-.5513.4485-1,1-1s1,.4487,1,1-.4485,1-1,1-1-.4487-1-1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CallsAll.propTypes = iconPropTypes;
}
const CallsIncoming = /*#__PURE__*/React.forwardRef(function CallsIncoming({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m26,12c-2.2091,0-4,1.7908-4,4s1.7909,4,4,4,4-1.7909,4-4-1.7908-4-4-4Zm0,6c-1.1028,0-2-.8972-2-2s.8972-2,2-2,2,.8972,2,2-.8972,2-2,2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m15,20l-1.4143,1.4141,2.5859,2.5859H7.8157c-.4141-1.1611-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8389,2.8157-2h8.356l-2.5859,2.5859,1.4143,1.4141,5-5-5-5Zm-10,6c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m15,4l-1.4143,1.4141,2.5859,2.5859H7.8157c-.4141-1.1611-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8389,2.8157-2h8.356l-2.5859,2.5859,1.4143,1.4141,5-5-5-5Zm-10,6c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CallsIncoming.propTypes = iconPropTypes;
}
const Camera = /*#__PURE__*/React.forwardRef(function Camera({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29,26H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H9.46l1.71-2.55A1,1,0,0,1,12,4h8a1,1,0,0,1,.83.45L22.54,7H29a1,1,0,0,1,1,1V25A1,1,0,0,1,29,26ZM4,24H28V9H22a1,1,0,0,1-.83-.45L19.46,6H12.54L10.83,8.55A1,1,0,0,1,10,9H4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Camera.propTypes = iconPropTypes;
}
const CameraAction = /*#__PURE__*/React.forwardRef(function CameraAction({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12,23a6,6,0,1,1,6-6A6,6,0,0,1,12,23Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,12,13Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29,27H3a1,1,0,0,1-1-1V6A1,1,0,0,1,3,5H29a1,1,0,0,1,1,1V26A1,1,0,0,1,29,27ZM4,25H28V7H4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9H26V11H19z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "17",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CameraAction.propTypes = iconPropTypes;
}
const Campsite = /*#__PURE__*/React.forwardRef(function Campsite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5618,26,17.17,8.9277,19.5361,5.04,17.8281,4,16,7.0049,14.17,4l-1.708,1.04,2.3665,3.8877L4.438,26H2v2H30V26ZM16,10.8506,25.2207,26H17V18H15v8H6.7791Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Campsite.propTypes = iconPropTypes;
}
const Car = /*#__PURE__*/React.forwardRef(function Car({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379,15.9336l-7.7324-2.7783L18.374,9.0967A2.99,2.99,0,0,0,16.0537,8H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,13.2949A4.9884,4.9884,0,0,0,2,16.1074V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V16.875A1,1,0,0,0,29.3379,15.9336ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,26Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V16.1074A2.9977,2.9977,0,0,1,4.52,14.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,10h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,17.5781Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Car.propTypes = iconPropTypes;
}
const CarFront = /*#__PURE__*/React.forwardRef(function CarFront({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19H19V21H13z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4409,14,24.1687,9.45A2.009,2.009,0,0,0,22.2456,8H9.7544A2.0089,2.0089,0,0,0,7.8313,9.4507L6.5315,14H4v2H6v7a2.0025,2.0025,0,0,0,2,2v3h2V25H22v3h2V25a2.0025,2.0025,0,0,0,2-2V16h2V14ZM9.7544,10H22.2458l1.4285,5H8.3257ZM24,21v2H8V21h2V19H8V17H24v2H22v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CarFront.propTypes = iconPropTypes;
}
const Carbon = /*#__PURE__*/React.forwardRef(function Carbon({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,30.8149a1.0011,1.0011,0,0,1-.4927-.13l-8.5-4.815A1,1,0,0,1,4,25V15a1,1,0,0,1,.5073-.87l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,23,15V25a1,1,0,0,1-.5073.87l-8.5,4.815A1.0011,1.0011,0,0,1,13.5,30.8149ZM6,24.417l7.5,4.2485L21,24.417V15.583l-7.5-4.2485L6,15.583Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17H26V7.583L18.5,3.3345,10.4927,7.87,9.5073,6.13l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,28,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Carbon.propTypes = iconPropTypes;
}
const CarbonUiBuilder = /*#__PURE__*/React.forwardRef(function CarbonUiBuilder({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28H30V30H24z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "29",
    r: "1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "25",
    r: "1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H26V26H20z",
    transform: "rotate(-180 23 25)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20H30V22H24z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4927,14.1299l-8.5-4.8149c-.3057-.1729-.6797-.1729-.9854,0L3.5073,14.1299c-.3135,.1777-.5073,.5098-.5073,.8701v10c0,.3604,.1938,.6924,.5073,.8701l8.5,4.8149,.9854-1.7402-7.9927-4.5278V15.583l7.5-4.2485,7.5,4.2485v2.417h2v-3c0-.3604-.1938-.6924-.5073-.8701Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25,15h2V7c0-.3604-.1938-.6924-.5073-.8701L17.9927,1.3149c-.3057-.1729-.6797-.1729-.9854,0L8.5074,6.1299l.9854,1.7402L17.5,3.3345l7.5,4.2485v7.417Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CarbonUiBuilder.propTypes = iconPropTypes;
}
const CarbonAccounting = /*#__PURE__*/React.forwardRef(function CarbonAccounting({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29,26H23V22a2.002,2.002,0,0,1,2-2h2V18H23V16h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H25v2h4Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19,22H15a2.0023,2.0023,0,0,1-2-2V10a2.002,2.002,0,0,1,2-2h4a2.002,2.002,0,0,1,2,2V20A2.0023,2.0023,0,0,1,19,22ZM15,10V20h4V10Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11,22H5a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,5,8h6v2H5V20h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CarbonAccounting.propTypes = iconPropTypes;
}
const CarbonForAem = /*#__PURE__*/React.forwardRef(function CarbonForAem({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "6",
    r: "1",
    strokeWidth: "0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "6",
    r: "1",
    strokeWidth: "0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "28.5",
    cy: "24.5",
    r: "1.5",
    strokeWidth: "0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "23.5",
    cy: "27.5",
    r: "1.5",
    strokeWidth: "0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "18.5",
    cy: "24.5",
    r: "1.5",
    strokeWidth: "0"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "18.5",
    cy: "19.5",
    r: "1.5",
    strokeWidth: "0"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "23.5",
    cy: "16.5",
    r: "1.5",
    strokeWidth: "0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "28.5",
    cy: "19.5",
    r: "1.5",
    strokeWidth: "0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,2H4c-1.1046,0-2,.8954-2,2v20c0,1.1046.8954,2,2,2h9v-2H4v-14h24v4h2V4c0-1.1046-.8954-2-2-2Zm0,6H4v-4h24v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CarbonForAem.propTypes = iconPropTypes;
}
const CarbonForIbmDotcom = /*#__PURE__*/React.forwardRef(function CarbonForIbmDotcom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M29.509,17.689l-6-3.55C23.352,14.046,23.176,14,23,14s-0.352,0.046-0.509,0.14l-6,3.55C16.187,17.869,16,18.196,16,18.55 v6.9c0,0.354,0.187,0.681,0.491,0.86l6,3.55C22.648,29.954,22.824,30,23,30s0.352-0.046,0.509-0.14l6-3.55 C29.813,26.131,30,25.804,30,25.45v-6.9C30,18.196,29.813,17.869,29.509,17.689z M28,24.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958 V24.88z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "6",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4C2.897,2,2,2.897,2,4v20c0,1.103,0.897,2,2,2h9v-2H4V10h24v4h2V4C30,2.897,29.103,2,28,2z M4,8V4h24v4H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CarbonForIbmDotcom.propTypes = iconPropTypes;
}
const CarbonForIbmProduct = /*#__PURE__*/React.forwardRef(function CarbonForIbmProduct({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22.509,12.689l-6-3.55C16.352,9.046,16.176,9,16,9s-0.352,0.046-0.509,0.14l-6,3.55C9.187,12.869,9,13.196,9,13.55v6.9 c0,0.354,0.187,0.681,0.491,0.86l6,3.55C15.648,24.954,15.824,25,16,25s0.352-0.046,0.509-0.14l6-3.55 C22.813,21.131,23,20.804,23,20.45v-6.9C23,13.196,22.813,12.869,22.509,12.689z M21,19.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958 V19.88z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M6,20.184V11.07l6.2-3.664l-1.017-1.722L4.491,9.639C4.187,9.819,4,10.146,4,10.5v9.684C2.839,20.598,2,21.698,2,23 c0,1.654,1.346,3,3,3s3-1.346,3-3C8,21.698,7.161,20.598,6,20.184z M5,24c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1 S5.551,24,5,24z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27,20c-1.654,0-3,1.346-3,3c0,0.353,0.072,0.687,0.185,1.002L16,28.838l-6.404-3.784l-1.017,1.722l6.912,4.084 C15.648,30.954,15.824,31,16,31s0.352-0.046,0.509-0.139l8.96-5.295C25.919,25.835,26.439,26,27,26c1.654,0,3-1.346,3-3 S28.654,20,27,20z M27,24c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1S27.551,24,27,24z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7c0.731,0,1.392-0.273,1.913-0.708L26,11.071V18h2v-7.5c0-0.354-0.187-0.681-0.491-0.861l-8.567-5.062 C18.978,4.39,19,4.198,19,4c0-1.654-1.346-3-3-3s-3,1.346-3,3S14.346,7,16,7z M16,3c0.551,0,1,0.448,1,1s-0.449,1-1,1s-1-0.448-1-1 S15.449,3,16,3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CarbonForIbmProduct.propTypes = iconPropTypes;
}
const CarbonForMobile = /*#__PURE__*/React.forwardRef(function CarbonForMobile({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m32,14h-2v-5.9258l-5.5039-3.2104,1.0078-1.7275,6,3.5c.3071.1792.4961.5083.4961.8638v6.5Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m20,22c-.1743,0-.3481-.0454-.5039-.1362l-6-3.5c-.3071-.1792-.4961-.5083-.4961-.8638v-7c0-.3555.189-.6846.4961-.8638l6-3.5c.3115-.1816.6963-.1816,1.0078,0l6,3.5c.3071.1792.4961.5083.4961.8638v7c0,.3555-.189.6846-.4961.8638l-6,3.5c-.1558.0908-.3296.1362-.5039.1362Zm-5-5.0742l5,2.9165,5-2.9165v-5.8516l-5-2.9165-5,2.9165v5.8516Z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "24.5",
    r: "1.5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m19,30H6c-1.1028,0-2-.8972-2-2V4c0-1.1028.8972-2,2-2h13v2H6v24h13v-4h2v4c0,1.1028-.8972,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CarbonForMobile.propTypes = iconPropTypes;
}
const CarbonForSalesforce = /*#__PURE__*/React.forwardRef(function CarbonForSalesforce({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.51,17.69l-6-3.55c-.16-.09-.33-.14-.51-.14s-.35.05-.51.14l-6,3.55c-.3.18-.49.51-.49.86v6.9c0,.35.19.68.49.86l6,3.55c.16.09.33.14.51.14s.35-.05.51-.14l6-3.55c.3-.18.49-.51.49-.86v-6.9c0-.35-.19-.68-.49-.86Zm-1.51,7.19l-5,2.96-5-2.96v-5.76l5-2.96,5,2.96v5.76Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23.4,4.47c-.65,0-1.28.09-1.88.27-1.06-1.36-2.68-2.17-4.4-2.17-1.17,0-2.28.36-3.22,1.03-1.11-1.02-2.57-1.6-4.09-1.6h-.01c-1.62,0-3.14.63-4.29,1.78-1.14,1.14-1.76,2.65-1.76,4.25,0,.56.08,1.1.23,1.63-1.24,1.02-1.98,2.55-1.97,4.18,0,2.97,2.39,5.39,5.34,5.39h.28c.98,1.81,2.89,2.98,4.99,2.98h0c.47,0,.94-.06,1.38-.17v-2.11c-.43.18-.9.28-1.38.28h0c-1.53,0-2.92-.97-3.44-2.4l-.3-.81-.84.17c-.23.05-.46.07-.69.07-1.84,0-3.34-1.53-3.34-3.4,0-1.2.64-2.33,1.68-2.94l.77-.45-.36-.82c-.23-.51-.34-1.05-.34-1.61,0-1.07.41-2.07,1.17-2.83.77-.77,1.79-1.19,2.87-1.19h0c1.25,0,2.46.6,3.22,1.59l.6.79,1.2-.96c.65-.55,1.46-.85,2.3-.85,1.29,0,2.49.72,3.14,1.87l.45.8.83-.38c.58-.26,1.21-.39,1.86-.39,2.54,0,4.6,2.09,4.6,4.65,0,1.07-.37,2.04-.98,2.83l1.75,1.01c.77-1.09,1.22-2.41,1.22-3.84,0-3.67-2.96-6.65-6.6-6.65h.01Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CarbonForSalesforce.propTypes = iconPropTypes;
}
const CaretDown = /*#__PURE__*/React.forwardRef(function CaretDown({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 8 4",
      fill: "currentColor",
      ...rest
    }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
      d: "M8 0L4 4 0 0z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12L16 22 8 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretDown.propTypes = iconPropTypes;
}
const CaretLeft = /*#__PURE__*/React.forwardRef(function CaretLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 5 8",
      fill: "currentColor",
      ...rest
    }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
      d: "M5 8L0 4 5 0z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24L10 16 20 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretLeft.propTypes = iconPropTypes;
}
const CaretRight = /*#__PURE__*/React.forwardRef(function CaretRight({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 5 8",
      fill: "currentColor",
      ...rest
    }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
      d: "M0 0L5 4 0 8z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L22 16 12 24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretRight.propTypes = iconPropTypes;
}
const CaretSort = /*#__PURE__*/React.forwardRef(function CaretSort({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24L16 32 8 24z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L16 0 24 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretSort.propTypes = iconPropTypes;
}
const CaretSortDown = /*#__PURE__*/React.forwardRef(function CaretSortDown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24L16 32 8 24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretSortDown.propTypes = iconPropTypes;
}
const CaretSortUp = /*#__PURE__*/React.forwardRef(function CaretSortUp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L16 0 24 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretSortUp.propTypes = iconPropTypes;
}
const CaretUp = /*#__PURE__*/React.forwardRef(function CaretUp({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 8 4",
      fill: "currentColor",
      ...rest
    }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
      d: "M0 4L4 0 8 4z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20L16 10 24 20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CaretUp.propTypes = iconPropTypes;
}
const CarouselHorizontal = /*#__PURE__*/React.forwardRef(function CarouselHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M22,26H10a2,2,0,0,1-2-2V8a2,2,0,0,1,2-2H22a2,2,0,0,1,2,2V24A2,2,0,0,1,22,26ZM10,8V24H22V8Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M4,24H0V22H4V10H0V8H4a2,2,0,0,1,2,2V22A2,2,0,0,1,4,24Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M32,24H28a2,2,0,0,1-2-2V10a2,2,0,0,1,2-2h4v2H28V22h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CarouselHorizontal.propTypes = iconPropTypes;
}
const CarouselVertical = /*#__PURE__*/React.forwardRef(function CarouselVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10V22a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V10A2,2,0,0,1,8,8H24A2,2,0,0,1,26,10ZM8,22H24V10H8Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M24,28v4H22V28H10v4H8V28a2,2,0,0,1,2-2H22A2,2,0,0,1,24,28Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M24,0V4a2,2,0,0,1-2,2H10A2,2,0,0,1,8,4V0h2V4H22V0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CarouselVertical.propTypes = iconPropTypes;
}
const Catalog = /*#__PURE__*/React.forwardRef(function Catalog({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H22V10H14z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15H22V17H14z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22H22V24H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Catalog.propTypes = iconPropTypes;
}
const CatalogPublish = /*#__PURE__*/React.forwardRef(function CatalogPublish({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20L21.4 21.4 18.8 24 28 24 28 26 18.8 26 21.4 28.6 20 30 15 25z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15H22V17H14z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H22V10H14z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M13,28H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18v16h2V4c0-1.1-0.9-2-2-2H8C6.9,2,6,2.9,6,4v4H4v2h2v5H4v2h2v5H4v2h2v4 c0,1.1,0.9,2,2,2h5V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CatalogPublish.propTypes = iconPropTypes;
}
const Categories = /*#__PURE__*/React.forwardRef(function Categories({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76,6l.45.89L7.76,8H12v5H4V6H6.76m.62-2H3A1,1,0,0,0,2,5v9a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H9L8.28,4.55A1,1,0,0,0,7.38,4Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M22.76,6l.45.89L23.76,8H28v5H20V6h2.76m.62-2H19a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H25l-.72-1.45a1,1,0,0,0-.9-.55Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76,19l.45.89L7.76,21H12v5H4V19H6.76m.62-2H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V20a1,1,0,0,0-1-1H9l-.72-1.45a1,1,0,0,0-.9-.55Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M22.76,19l.45.89L23.76,21H28v5H20V19h2.76m.62-2H19a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V20a1,1,0,0,0-1-1H25l-.72-1.45a1,1,0,0,0-.9-.55Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Categories.propTypes = iconPropTypes;
}
const Category = /*#__PURE__*/React.forwardRef(function Category({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.1414V18a2,2,0,0,0-2-2H17V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.002,2.002,0,0,0-2,2v6a2.002,2.002,0,0,0,2,2h2v4H7a2,2,0,0,0-2,2v4.1421a4,4,0,1,0,2,0V18h8v4.142a4,4,0,1,0,2,0V18h8v4.1414a4,4,0,1,0,2,0ZM13,4h6l.001,6H13ZM8,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,26Zm10,0a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,18,26Zm8,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Category.propTypes = iconPropTypes;
}
const CategoryAdd = /*#__PURE__*/React.forwardRef(function CategoryAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6L13.59 7.41 17.17 11 13.59 14.59 15 16 20 11 15 6z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CategoryAdd.propTypes = iconPropTypes;
}
const CategoryAnd = /*#__PURE__*/React.forwardRef(function CategoryAnd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M4,30V26H15v4h2V26H28v4h2V26a2,2,0,0,0-2-2H17V19H15v5H4a2,2,0,0,0-2,2v4Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6953,13.9858A10.08,10.08,0,0,0,21.9463,10H23V8H20V9a9.2634,9.2634,0,0,1-.6641,3.2705L16.6511,8.8816a5.1261,5.1261,0,0,0,2.1436-2.3694A3.2522,3.2522,0,0,0,18.6062,3.81a3.38,3.38,0,0,0-2.2391-1.7056,3.4688,3.4688,0,0,0-4.2223,2.1186c-.5044,1.5518.4406,3.1158,1.2612,4.1077A4.7255,4.7255,0,0,0,11.06,13.1587,4.4526,4.4526,0,0,0,15.4268,17h.0058a5.7844,5.7844,0,0,0,3.9717-1.4233L20.532,17h2.5519ZM14.047,4.8413A1.3224,1.3224,0,0,1,15.4141,4a2.41,2.41,0,0,1,.5214.0581,1.4018,1.4018,0,0,1,.9111.7022,1.2493,1.2493,0,0,1,.0791,1.042A3.6871,3.6871,0,0,1,15.2441,7.395C14.5831,6.6816,13.8087,5.5732,14.047,4.8413ZM15.4316,15h-.0039a2.4432,2.4432,0,0,1-2.3916-2.1509,2.8261,2.8261,0,0,1,1.81-3.0249l3.3115,4.1787A3.8853,3.8853,0,0,1,15.4316,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CategoryAnd.propTypes = iconPropTypes;
}
const CategoryNew = /*#__PURE__*/React.forwardRef(function CategoryNew({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CategoryNew.propTypes = iconPropTypes;
}
const CategoryNewEach = /*#__PURE__*/React.forwardRef(function CategoryNewEach({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M29,10H24v2h5v6H22v2h3v2.142a4,4,0,1,0,2,0V20h2a2.0027,2.0027,0,0,0,2-2V12A2.0023,2.0023,0,0,0,29,10ZM28,26a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,28,26Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M19,6H14V8h5v6H12v2h3v6.142a4,4,0,1,0,2,0V16h2a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,19,6ZM18,26a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,18,26Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M9,2H3A2.002,2.002,0,0,0,1,4v6a2.002,2.002,0,0,0,2,2H5V22.142a4,4,0,1,0,2,0V12H9a2.002,2.002,0,0,0,2-2V4A2.002,2.002,0,0,0,9,2ZM8,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,26ZM3,10V4H9l.0015,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CategoryNewEach.propTypes = iconPropTypes;
}
const Caution = /*#__PURE__*/React.forwardRef(function Caution({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
      d: "M12.3154,12H3.6846L8,4.0884,12.3154,12M14,13,8,2,2,13Z"
    })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
      d: "M12.315 12L3.685 12 8 4.088 12.315 12z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3154,12H3.6846L8,4.0884,12.3154,12M14,13,8,2,2,13Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M12.315 12L3.685 12 8 4.088 12.315 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Caution.propTypes = iconPropTypes;
}
const CautionInverted = /*#__PURE__*/React.forwardRef(function CautionInverted({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
      d: "M8 14L2 3 14 3 8 14z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14L2 3 14 3 8 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CautionInverted.propTypes = iconPropTypes;
}
const QCcX = /*#__PURE__*/React.forwardRef(function QCcX({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M10,23H5a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H5v6h5Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M19,23H14a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H14v6h5Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M29 9L27 9 25 15 23 9 21 9 23.75 16 21 23 23 23 25 17 27 23 29 23 26.25 16 29 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QCcX.propTypes = iconPropTypes;
}
const WatsonHealthCdArchive = /*#__PURE__*/React.forwardRef(function WatsonHealthCdArchive({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A12,12,0,1,1,28,16,12,12,0,0,1,16,28ZM16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthCdArchive.propTypes = iconPropTypes;
}
const WatsonHealthCdCreateArchive = /*#__PURE__*/React.forwardRef(function WatsonHealthCdCreateArchive({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a6,6,0,1,1,6-6A6,6,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,14,10Z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M17,23.54A10,10,0,1,1,24,14c0,.34,0,.67-.05,1h2c0-.33.05-.66.05-1A12,12,0,1,0,14,26a12.33,12.33,0,0,0,3-.39Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30l-2.14-1A5,5,0,0,1,20,24.47V18H30v6.47A5,5,0,0,1,27.14,29ZM22,20v4.47a3,3,0,0,0,1.72,2.71l1.28.61,1.28-.61A3,3,0,0,0,28,24.47V20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthCdCreateArchive.propTypes = iconPropTypes;
}
const WatsonHealthCdCreateExchange = /*#__PURE__*/React.forwardRef(function WatsonHealthCdCreateExchange({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M14,2a12,12,0,0,0,0,24V24A10,10,0,1,1,24,14,8.27,8.27,0,0,1,24,15h2c0-.33.05-.66.05-1A12,12,0,0,0,14,2Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24L26.17 24 23.58 26.59 25 28 30 23 25 18 23.58 19.42 26.17 22 17 22 17 24z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a6,6,0,1,1,6-6A6,6,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,14,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthCdCreateExchange.propTypes = iconPropTypes;
}
const Cda = /*#__PURE__*/React.forwardRef(function Cda({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H24a2.002,2.002,0,0,0-2,2V23h2V18h4v5h2V11A2.0023,2.0023,0,0,0,28,9Zm-4,7V11h4v5Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23H12V9h4a4.0042,4.0042,0,0,1,4,4v6A4.0039,4.0039,0,0,1,16,23Zm-2-2h2a2.0027,2.0027,0,0,0,2-2V13a2.0023,2.0023,0,0,0-2-2H14Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M10,23H4a2.0023,2.0023,0,0,1-2-2V11A2.002,2.002,0,0,1,4,9h6v2H4V21h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Cda.propTypes = iconPropTypes;
}
const CellTower = /*#__PURE__*/React.forwardRef(function CellTower({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L25 16 17 16 17 11 15 11 15 16 7 16 7 11 5 11 5 23 7 23 7 18 10 18 10 30 12 30 12 18 15 18 15 23 17 23 17 18 20 18 20 30 22 30 22 18 25 18 25 23 27 23 27 11z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6c-1.7,0-3.2,0.7-4.2,1.8l1.4,1.4C13.9,8.4,14.9,8,16,8s2.1,0.4,2.8,1.2l1.4-1.4C19.2,6.7,17.7,6,16,6z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9,4.9l1.4,1.4C11.8,4.9,13.8,4,16,4s4.2,0.9,5.7,2.3l1.4-1.4C21.3,3.1,18.8,2,16,2S10.7,3.1,8.9,4.9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CellTower.propTypes = iconPropTypes;
}
const CenterCircle = /*#__PURE__*/React.forwardRef(function CenterCircle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V22H15v3.9492A10.0166,10.0166,0,0,1,6.0508,17H10V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V10h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H22v2h3.9492A10.0166,10.0166,0,0,1,17,25.9492Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CenterCircle.propTypes = iconPropTypes;
}
const CenterSquare = /*#__PURE__*/React.forwardRef(function CenterSquare({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L4 12 4 4 12 4 12 6 6 6 6 12z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12L26 12 26 6 20 6 20 4 28 4 28 12z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28L4 28 4 20 6 20 6 26 12 26 12 28z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28L20 28 20 26 26 26 26 20 28 20 28 28z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V14H15z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H14V17H10z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15H22V17H18z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V22H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CenterSquare.propTypes = iconPropTypes;
}
const CenterToFit = /*#__PURE__*/React.forwardRef(function CenterToFit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2L2 2 2 8 4 8 4 4 8 4 8 2z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2L30 2 30 8 28 8 28 4 24 4 24 2z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30L2 30 2 24 4 24 4 28 8 28 8 30z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30L30 30 30 24 28 24 28 28 24 28 24 30z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H8a2.0023,2.0023,0,0,1-2-2V10A2.0023,2.0023,0,0,1,8,8H24a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,24,24ZM8,10V22H24V10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CenterToFit.propTypes = iconPropTypes;
}
const Certificate = /*#__PURE__*/React.forwardRef(function Certificate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17L25.912 20.703 30 21.297 27 24 27.771 28 24 25.75 20.229 28 21 24 18 21.297 22.2 20.703 24 17z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H12V18H6z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H16V14H6z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H16V10H6z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Certificate.propTypes = iconPropTypes;
}
const CertificateCheck = /*#__PURE__*/React.forwardRef(function CertificateCheck({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H12V18H6z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H16V14H6z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H16V10H6z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M22 25.59L19.41 23 18 24.41 22 28.41 30 20.41 28.59 19 22 25.59z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CertificateCheck.propTypes = iconPropTypes;
}
const ChangeCatalog = /*#__PURE__*/React.forwardRef(function ChangeCatalog({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24v2h2.4592A5.94,5.94,0,0,1,22,28a6.0066,6.0066,0,0,1-6-6H14a7.9841,7.9841,0,0,0,14,5.2651V30h2V24Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a8.04,8.04,0,0,0-6,2.7349V14H14v6h6V18H17.5408A5.94,5.94,0,0,1,22,16a6.0066,6.0066,0,0,1,6,6h2A8.0092,8.0092,0,0,0,22,14Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H6V24H8V22H6V17H8V15H6V10H8V8H6V4H24v8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8H2v2H4v5H2v2H4v5H2v2H4v4a2,2,0,0,0,2,2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChangeCatalog.propTypes = iconPropTypes;
}
const Channels = /*#__PURE__*/React.forwardRef(function Channels({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M10,15v-7.2l3.6,3.6,1.4-1.4-6-6-6,6,1.4,1.4,3.6-3.6v12.34c-1.72.45-3,2-3,3.86,0,2.21,1.79,4,4,4s4-1.79,4-4c0-1.86-1.28-3.41-3-3.86v-5.14ZM11,24c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2ZM27.6,20.6l-3.6,3.6v-12.34c1.72-.45,3-2,3-3.86,0-2.21-1.79-4-4-4s-4,1.79-4,4c0,1.86,1.28,3.41,3,3.86v12.34l-3.6-3.6-1.4,1.4,6,6,6-6-1.4-1.4ZM21,8c0-1.1.9-2,2-2s2,.9,2,2-.9,2-2,2-2-.9-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Channels.propTypes = iconPropTypes;
}
const CharacterDecimal = /*#__PURE__*/React.forwardRef(function CharacterDecimal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15H23V17H21z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M24,23H20a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2V21A2.0027,2.0027,0,0,1,24,23ZM20,11h0V21h4V11Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15H13V17H11z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H10a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2V21A2.0027,2.0027,0,0,1,14,23ZM10,11h0V21h4V11Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21H6V23H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterDecimal.propTypes = iconPropTypes;
}
const CharacterFraction = /*#__PURE__*/React.forwardRef(function CharacterFraction({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H20V24a2.002,2.002,0,0,1,2-2h4V18H20V16h6a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H22v4h6Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M4.479 15.5H26.521V17.5H4.479z",
    transform: "rotate(-45 15.5 16.5)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.5L4.5 14.5 7.5 14.5 7.5 3.5 4.5 3.5 4.5 2.5 8.5 2.5 8.5 14.5 11.5 14.5 11.5 15.5 4.5 15.5z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M8,3V15H8V3M9,2H4V4H7V14H4v2h8V14H9V2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterFraction.propTypes = iconPropTypes;
}
const CharacterInteger = /*#__PURE__*/React.forwardRef(function CharacterInteger({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21H15V23H5z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13L11 13 11 9 9 9 9 13 5 13 5 15 9 15 9 19 11 19 11 15 15 15 15 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterInteger.propTypes = iconPropTypes;
}
const CharacterLowerCase = /*#__PURE__*/React.forwardRef(function CharacterLowerCase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M29,23H24a2.0027,2.0027,0,0,1-2-2V15a2.0023,2.0023,0,0,1,2-2h5v2H24v6h5Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M18,13H14V9H12V23h6a2.0027,2.0027,0,0,0,2-2V15A2.0023,2.0023,0,0,0,18,13Zm-4,8V15h4v6Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M8,13H3v2H8v2H4a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V15A2.0023,2.0023,0,0,0,8,13Zm0,8H4V19H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterLowerCase.propTypes = iconPropTypes;
}
const CharacterNegativeNumber = /*#__PURE__*/React.forwardRef(function CharacterNegativeNumber({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H15V17H5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterNegativeNumber.propTypes = iconPropTypes;
}
const CharacterSentenceCase = /*#__PURE__*/React.forwardRef(function CharacterSentenceCase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M29,23H24a2.0027,2.0027,0,0,1-2-2V15a2.0023,2.0023,0,0,1,2-2h5v2H24v6h5Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M18,13H14V9H12V23h6a2.0027,2.0027,0,0,0,2-2V15A2.0023,2.0023,0,0,0,18,13Zm-4,8V15h4v6Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M8,9H4a2.002,2.002,0,0,0-2,2V23H4V18H8v5h2V11A2.002,2.002,0,0,0,8,9ZM4,16V11H8v5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterSentenceCase.propTypes = iconPropTypes;
}
const CharacterUpperCase = /*#__PURE__*/React.forwardRef(function CharacterUpperCase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23H24a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H24V21h6Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12a3.0033,3.0033,0,0,0-3-3H12V23h5a3.0033,3.0033,0,0,0,3-3V18a2.977,2.977,0,0,0-.78-2A2.9768,2.9768,0,0,0,20,14Zm-6-1h3a1.0013,1.0013,0,0,1,1,1v2a1.0013,1.0013,0,0,1-1,1H14Zm4,9a1.0009,1.0009,0,0,1-1,1H14V17h3a1.0009,1.0009,0,0,1,1,1Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M8,9H4a2.002,2.002,0,0,0-2,2V23H4V18H8v5h2V11A2.002,2.002,0,0,0,8,9ZM4,16V11H8v5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterUpperCase.propTypes = iconPropTypes;
}
const CharacterWholeNumber = /*#__PURE__*/React.forwardRef(function CharacterWholeNumber({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H22v2h6v4H24v2h4v4H22v2h6a2.0027,2.0027,0,0,0,2-2V11A2.0023,2.0023,0,0,0,28,9Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M20,23H12V17a2.002,2.002,0,0,1,2-2h4V11H12V9h6a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H14v4h6Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 22.5L2.5 21.5 5.5 21.5 5.5 10.5 2.5 10.5 2.5 9.5 6.5 9.5 6.5 21.5 9.5 21.5 9.5 22.5 2.5 22.5z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M6,10V22H6V10M7,9H2v2H5V21H2v2h8V21H7V9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterWholeNumber.propTypes = iconPropTypes;
}
const CharacterPatterns = /*#__PURE__*/React.forwardRef(function CharacterPatterns({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M6,26V17.8281l-3.5859,3.586L1,20l6-6,6,6-1.4141,1.4141L8,17.8281V26H18v2H8A2.0024,2.0024,0,0,1,6,26Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22L30 20 22 20 22 22 27.5 22 22 28 22 30 30 30 30 28 24.507 28 30 22z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v8.1719l3.5859-3.586L31,12l-6,6-6-6,1.4141-1.4141L24,14.1719V6H14V4H24A2.0024,2.0024,0,0,1,26,6Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M8,2H3V4H8V6H4A2,2,0,0,0,2,8v2a2,2,0,0,0,2,2h6V4A2.0023,2.0023,0,0,0,8,2Zm0,8H4V8H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CharacterPatterns.propTypes = iconPropTypes;
}
const ChargingStation = /*#__PURE__*/React.forwardRef(function ChargingStation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M30,7H29V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1ZM17,26H6V6H17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChargingStation.propTypes = iconPropTypes;
}
const ChargingStationFilled = /*#__PURE__*/React.forwardRef(function ChargingStationFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M29,7V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1V7ZM11.8574,21.5146l-1.7148-1.0292L12.2339,17h-5l3.9087-6.5146,1.7148,1.0292L10.7661,15h5Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChargingStationFilled.propTypes = iconPropTypes;
}
const Chart_3D = /*#__PURE__*/React.forwardRef(function Chart_3D({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M28,23v3.5859l-5-5V15a1,1,0,0,0-.5527-.8945L17,11.3818V5.8281l2.5859,2.586L21,7,16,2,11,7l1.4141,1.4141L15,5.8281v5.5537L9.5527,14.1055A1,1,0,0,0,9,15v6.5859l-5,5V23H2v7H9V28H5.4141l4.7832-4.7832,5.3554,2.6777a1.001,1.001,0,0,0,.8946,0l5.3554-2.6777L26.5859,28H23v2h7V23Zm-13,.3818-4-2V16.6182l4,2Zm1-6.5L12.2363,15,16,13.1182,19.7637,15Zm5,4.5-4,2V18.6182l4-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Chart_3D.propTypes = iconPropTypes;
}
const ChartArea = /*#__PURE__*/React.forwardRef(function ChartArea({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4761,8.0151,13.4473,4.2109a2.0076,2.0076,0,0,0-2.1158.2051L4,10.001V2H2V28a2,2,0,0,0,2,2H30V5.7354ZM28,20.209l-7.62,1.8022-7.0288-2.8838a1.99,1.99,0,0,0-2.022.37L4,25.8359v-4.455l8.375-9.4,7.0186,5.62a2.0155,2.0155,0,0,0,2.0459.2119L28,14.6025ZM12.5239,5.9849l7.03,3.8042a2.012,2.012,0,0,0,1.3408.16L28,8.2646v4.1138L20.6187,16.02,13.6,10.4a1.99,1.99,0,0,0-2.6885.2642L4,18.3838v-5.87ZM4.5513,28,12.62,20.9888l7.0288,2.8838a1.9977,1.9977,0,0,0,1.147.0771L28,22.2612V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartArea.propTypes = iconPropTypes;
}
const ChartAreaSmooth = /*#__PURE__*/React.forwardRef(function ChartAreaSmooth({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6.6143l-1.3152.4365A20.9218,20.9218,0,0,1,23,8c-1.7344,0-3.3225-.9072-5.0039-1.8682C16.1621,5.084,14.2656,4,12,4,9.123,4,5.9146,6.2061,4,7.772V2H2V28a2.0025,2.0025,0,0,0,2,2H30ZM4,20.2944C5.874,17.3765,9.56,13,12,13c1.6379,0,2.96,1.1016,4.36,2.2686C17.8965,16.5488,19.6379,18,22,18a9.4686,9.4686,0,0,0,6-2.5288v4.9556A13.0026,13.0026,0,0,1,22,22a13.8619,13.8619,0,0,1-4.6838-.9487A15.682,15.682,0,0,0,12,20c-2.927,0-6.0676,2.959-8,5.1577ZM12,6c1.7344,0,3.3225.9072,5.0039,1.8682C18.8379,8.916,20.7344,10,23,10a21.432,21.432,0,0,0,5-.6782v3.3213C27.3167,13.4463,24.9155,16,22,16c-1.6379,0-2.96-1.1016-4.36-2.2686C16.1035,12.4512,14.3621,11,12,11c-2.9358,0-6.0632,3.3394-8,5.8447V10.4238C5.5461,8.9658,9.2588,6,12,6ZM4.249,28C5.8623,25.9087,9.41,22,12,22a13.8619,13.8619,0,0,1,4.6838.9487A15.682,15.682,0,0,0,22,24a14.7362,14.7362,0,0,0,6-1.34V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartAreaSmooth.propTypes = iconPropTypes;
}
const ChartAreaStepper = /*#__PURE__*/React.forwardRef(function ChartAreaStepper({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M22,10V6H10v6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V10ZM12,14V8h8v4h8V22H22V16H12v6H4V14ZM4,28V24H14V18h6v6h8v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartAreaStepper.propTypes = iconPropTypes;
}
const ChartAverage = /*#__PURE__*/React.forwardRef(function ChartAverage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M23,24c-3.5991,0-5.0293-4.1758-6.4126-8.2139C15.2764,11.9583,13.92,8,11,8a3.44,3.44,0,0,0-3.0532,2.3215L6.0513,9.6838C6.1016,9.5334,7.3218,6,11,6c4.3491,0,6.0122,4.8547,7.48,9.1379C19.6885,18.6667,20.83,22,23,22a3.44,3.44,0,0,0,3.0532-2.3215l1.8955.6377C27.8984,20.4666,26.6782,24,23,24Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M4,28V17H6V15H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H10V17H8z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H14V17H12z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15H22V17H20z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15H26V17H24z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15H30V17H28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartAverage.propTypes = iconPropTypes;
}
const ChartBar = /*#__PURE__*/React.forwardRef(function ChartBar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBar.propTypes = iconPropTypes;
}
const ChartBarFloating = /*#__PURE__*/React.forwardRef(function ChartBarFloating({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24H14V16H28ZM16,22H26V18H16Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M26,12H8V4H26ZM10,10H24V6H10Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBarFloating.propTypes = iconPropTypes;
}
const ChartBarOverlay = /*#__PURE__*/React.forwardRef(function ChartBarOverlay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M4,28V26H26V16H4V14H18V4H4V2H2V28a2,2,0,0,0,2,2H30V28ZM24,18v6H4V22H20V20H4V18ZM16,6v6H4V10h8V8H4V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBarOverlay.propTypes = iconPropTypes;
}
const ChartBarStacked = /*#__PURE__*/React.forwardRef(function ChartBarStacked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M4,28V25H26V17H4V13H18V5H4V2H2V28a2,2,0,0,0,2,2H30V28Zm20-5H14V19H24ZM16,11H10V7h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBarStacked.propTypes = iconPropTypes;
}
const ChartBarTarget = /*#__PURE__*/React.forwardRef(function ChartBarTarget({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17H30V25H28z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5H22V13H20z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBarTarget.propTypes = iconPropTypes;
}
const ChartBubble = /*#__PURE__*/React.forwardRef(function ChartBubble({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-2a4,4,0,1,0,4,4,4,4,0,0,0-4-4Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M21,6a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,21A1.5,1.5,0,1,1,23,22.5,1.5,1.5,0,0,1,24.5,21m0-2A3.5,3.5,0,1,0,28,22.5,3.5,3.5,0,0,0,24.5,19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBubble.propTypes = iconPropTypes;
}
const ChartBubblePacked = /*#__PURE__*/React.forwardRef(function ChartBubblePacked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5322,17.1724A8.99,8.99,0,1,0,13.6074,5.88,5.9969,5.9969,0,1,0,5.051,13.2217a6.9967,6.9967,0,1,0,7.9942,11.4844A5.9981,5.9981,0,0,0,25,24c0-.1216-.011-.24-.0181-.3594a3.4873,3.4873,0,1,0,2.55-6.4682ZM21,4a7,7,0,1,1-7,7A7.0078,7.0078,0,0,1,21,4ZM8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4ZM19,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBubblePacked.propTypes = iconPropTypes;
}
const ChartBullet = /*#__PURE__*/React.forwardRef(function ChartBullet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M30,22H16V21H14v1H2v6H14v1h2V28H30ZM4,26V24H14v2Zm24,0H16V24H28Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13H24V12H22v1H2v6H22v1h2V19h6ZM4,17V15H22v2Zm24,0H24V15h4Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4H10V3H8V4H2v6H8v1h2V10H30ZM4,8V6H8V8ZM28,8H10V6H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartBullet.propTypes = iconPropTypes;
}
const ChartCandlestick = /*#__PURE__*/React.forwardRef(function ChartCandlestick({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H24V6H22v4H20V22h2v4h2V22h2ZM24,20H22V12h2Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M14,8H12V4H10V8H8V18h2v4h2V18h2Zm-2,8H10V10h2Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartCandlestick.propTypes = iconPropTypes;
}
const ChartClusterBar = /*#__PURE__*/React.forwardRef(function ChartClusterBar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16H12V26H10z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22H9V26H7z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H28V26H26z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M23 14H25V26H23z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V26H15z",
    transform: "rotate(-180 16 19)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H20V26H18z",
    transform: "rotate(-180 19 22)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartClusterBar.propTypes = iconPropTypes;
}
const ChartColumn = /*#__PURE__*/React.forwardRef(function ChartColumn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M27,28V6H19V28H15V14H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V16h4Zm12,0H21V8h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartColumn.propTypes = iconPropTypes;
}
const ChartColumnFloating = /*#__PURE__*/React.forwardRef(function ChartColumnFloating({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22H20V4h8Zm-6-2h4V6H22Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24H8V10h8Zm-6-2h4V12H10Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2.0021,2.0021,0,0,1-2-2V2H4V28H30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartColumnFloating.propTypes = iconPropTypes;
}
const ChartColumnTarget = /*#__PURE__*/React.forwardRef(function ChartColumnTarget({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M27,28V6H19V28H15V14H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V16h4Zm12,0H21V8h4Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H27V4H19z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10H15V12H7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartColumnTarget.propTypes = iconPropTypes;
}
const ChartCombo = /*#__PURE__*/React.forwardRef(function ChartCombo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V14h4Zm12,0H21V18h4Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartCombo.propTypes = iconPropTypes;
}
const ChartComboStacked = /*#__PURE__*/React.forwardRef(function ChartComboStacked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,14v6H9V14Zm12,4v6H21V18Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartComboStacked.propTypes = iconPropTypes;
}
const ChartCustom = /*#__PURE__*/React.forwardRef(function ChartCustom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15H21V17H17z",
    transform: "rotate(-90 19 16)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H18V16H12z",
    transform: "rotate(-90 15 15)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H16V14H6z",
    transform: "rotate(-90 11 13)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartCustom.propTypes = iconPropTypes;
}
const ChartDualYAxis = /*#__PURE__*/React.forwardRef(function ChartDualYAxis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "m28,2v5.7222l-7.5317,6.9521L12.3818,6.5879c-.3918-.3911-.9111-.5918-1.4302-.5879-.4644.0034-.9285.1714-1.301.4976l-5.6506,4.9443V2h-2v26c0,1.1025.8972,2,2,2h24c1.1028,0,2-.8975,2-2V2h-2Zm0,8.4438v11.7622l-6.1165-6.1162,6.1165-5.646Zm-17.0322-2.4414l8.0298,8.0298-3.2141,2.9668-3.4148-3.415c-.3711-.3706-.8564-.5674-1.3479-.584s-.9885.1475-1.3833.4932l-5.6375,4.9326v-6.3262l6.9678-6.0972Zm-6.9678,19.9976v-4.9165l6.9546-6.085,3.4146,3.4146c.3809.3809.8755.5771,1.374.5869s1.0007-.166,1.3967-.5312l3.2729-3.0215,7.5872,7.5869v2.9658H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartDualYAxis.propTypes = iconPropTypes;
}
const ChartErrorBar = /*#__PURE__*/React.forwardRef(function ChartErrorBar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M22,28V12H18V8h2V6H14V8h2v4H12V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM14,14h2v4H14Zm6,14H14V20h6Zm0-10H18V14h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartErrorBar.propTypes = iconPropTypes;
}
const ChartErrorBarAlt = /*#__PURE__*/React.forwardRef(function ChartErrorBarAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M14,10V8H8v2h2v4.1836a2.983,2.983,0,0,0,0,5.6328V24H8v2h6V24H12V19.8164a2.983,2.983,0,0,0,0-5.6328V10Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6V4H20V6h2V8.1836a2.983,2.983,0,0,0,0,5.6328V18H20v2h6V18H24V13.8164a2.983,2.983,0,0,0,0-5.6328V6Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartErrorBarAlt.propTypes = iconPropTypes;
}
const ChartEvaluation = /*#__PURE__*/React.forwardRef(function ChartEvaluation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M25.672 6.207H29.915V8.206H25.672z",
    transform: "rotate(-45.02 27.793 7.207)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5L11 15.539 12.59 13.969 16 17.349 23.41 10 25 11.579 16 20.5z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M4,28V25.4131L10.4141,19,9,17.585l-5,5V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartEvaluation.propTypes = iconPropTypes;
}
const ChartHighLow = /*#__PURE__*/React.forwardRef(function ChartHighLow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8L12 8 12 6 10 6 10 20 7 20 7 22 10 22 10 24 12 24 12 10 15 10 15 8z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10L24 10 24 6 22 6 22 18 19 18 19 20 22 20 22 24 24 24 24 12 27 12 27 10z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartHighLow.propTypes = iconPropTypes;
}
const ChartHistogram = /*#__PURE__*/React.forwardRef(function ChartHistogram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M6,16c2.9727,0,4.2324-2.251,5.3447-4.2373C12.4741,9.7441,13.45,8,16,8s3.5259,1.7441,4.6553,3.7627C21.7676,13.749,23.0273,16,26,16h4V14H26c-1.7129,0-2.4834-1.2207-3.5991-3.2144C21.2075,8.6543,19.7231,6,16,6s-5.2075,2.6543-6.4009,4.7856C8.4834,12.7793,7.7129,14,6,14H4V2H2V28a2,2,0,0,0,2,2H30V28H28V22H26v6H21.9992L22,20H20v8H16V16H14V28H9.9992L10,20H8v8H4V16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartHistogram.propTypes = iconPropTypes;
}
const ChartLine = /*#__PURE__*/React.forwardRef(function ChartLine({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67,28l6.39-12,7.3,6.49a2,2,0,0,0,1.7.47,2,2,0,0,0,1.42-1.07L27,10.9,25.18,10,19.69,21l-7.3-6.49A2,2,0,0,0,10.71,14a2,2,0,0,0-1.42,1L4,25V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartLine.propTypes = iconPropTypes;
}
const ChartLineData = /*#__PURE__*/React.forwardRef(function ChartLineData({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M10.06,17.88A4.25,4.25,0,0,0,11,18a4,4,0,0,0,2.23-.68l3.22,2.87a3.88,3.88,0,0,0-.2,3.17A4,4,0,1,0,22.62,19l2.54-5.09a3.78,3.78,0,0,0,2.91-.53A4,4,0,1,0,23.38,13l-2.54,5.09A3.86,3.86,0,0,0,20,18a4,4,0,0,0-2.23.68l-3.22-2.87a3.88,3.88,0,0,0,.2-3.17A4,4,0,1,0,8.3,16.93L4,25V2H2V28a2,2,0,0,0,2,2H30V28H4.67ZM26,8a2,2,0,1,1-2,2A2,2,0,0,1,26,8ZM22,22a2,2,0,1,1-2-2A2,2,0,0,1,22,22ZM11,12a2,2,0,1,1-2,2A2,2,0,0,1,11,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartLineData.propTypes = iconPropTypes;
}
const ChartLineSmooth = /*#__PURE__*/React.forwardRef(function ChartLineSmooth({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M13,15c1.4854,0,2.5544,1.4966,3.6863,3.0811C17.9983,19.918,19.4854,22,22,22c5.6709,0,7.78-10.79,8-12l-1.9678-.3584C27.55,12.2827,25.3938,20,22,20c-1.4854,0-2.5544-1.4966-3.6863-3.0811C17.0017,15.082,15.5146,13,13,13c-4.186,0-7.4448,7.4043-9,11.7617V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H5.0439C6.5544,22.8574,9.9634,15,13,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartLineSmooth.propTypes = iconPropTypes;
}
const ChartLogisticRegression = /*#__PURE__*/React.forwardRef(function ChartLogisticRegression({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "22",
    r: "2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "22",
    r: "2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "6",
    r: "2"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "6",
    r: "2"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m8.2339,24c3.8799,0,7.311-2.4731,8.5383-6.1543l2.353-7.0591c.9543-2.8628,3.6233-4.7866,6.6409-4.7866h4.2339v-2h-4.2339c-3.8799,0-7.311,2.4731-8.5383,6.1543l-2.353,7.0591c-.9543,2.8628-3.6233,4.7866-6.6409,4.7866h-4.2339V2h-2v26c0,1.1025.897,2,2,2h26v-2H4v-4h4.2339Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartLogisticRegression.propTypes = iconPropTypes;
}
const ChartMarimekko = /*#__PURE__*/React.forwardRef(function ChartMarimekko({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,7H21V5h6ZM19,8H13V5h6Zm0,2v8H13V10ZM11,22H5V12h6Zm2-2h6v7H13Zm8-8h6v4H21ZM11,5v5H5V5ZM5,24h6v3H5Zm16,3V18h6v9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartMarimekko.propTypes = iconPropTypes;
}
const ChartMaximum = /*#__PURE__*/React.forwardRef(function ChartMaximum({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H10V8H8z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H14V8H12z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H22V8H20z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H26V8H24z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H30V8H28z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M27.989,28l-.0271-.1631C26.5105,19.0742,24.0662,9.0894,18,8.0889V6H16V8.085c-6.084.978-8.533,10.9775-9.9863,19.7519L5.9866,28H4V8H6V6H4V2H2V28a2,2,0,0,0,2,2H30V28ZM8.0151,28c2.024-12.1084,4.959-18,8.9727-18s6.9487,5.8916,8.9726,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartMaximum.propTypes = iconPropTypes;
}
const ChartMedian = /*#__PURE__*/React.forwardRef(function ChartMedian({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H18V24H16z",
    transform: "rotate(-90 17 23)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28V26H16v2H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0532,19.6787A3.44,3.44,0,0,1,23,22c-2.17,0-3.3115-3.333-4.52-6.8623-.3557-1.0386-.7239-2.1094-1.1382-3.1377H18V10H16.4221C15.2124,7.7148,13.5811,6,11,6,7.3218,6,6.1016,9.5332,6.0513,9.6836l1.8955.6377A3.44,3.44,0,0,1,11,8c2.92,0,4.2764,3.958,5.5874,7.7861.2544.7422.5105,1.4893.7813,2.2139H16v2h2.2019c1.0828,2.2886,2.4959,4,4.7981,4,3.6782,0,4.8984-3.5332,4.9487-3.6836Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H18V8H16z",
    transform: "rotate(-90 17 7)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H18V4H16z",
    transform: "rotate(-90 17 3)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartMedian.propTypes = iconPropTypes;
}
const ChartMinimum = /*#__PURE__*/React.forwardRef(function ChartMinimum({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M4,28V26H6V24H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H10V26H8z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H14V26H12z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H22V26H20z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H26V26H24z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24H30V26H28z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9463,4.3281,25.9727,4C23.9487,16.1084,21.0137,22,17,22S10.0513,16.1084,8.0271,4l-1.9734.3281C7.51,13.0566,9.9631,22.93,16,23.9131V26h2V23.9131C24.0371,22.93,26.4907,13.0566,27.9463,4.3281Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartMinimum.propTypes = iconPropTypes;
}
const ChartMultiLine = /*#__PURE__*/React.forwardRef(function ChartMultiLine({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5859,28l7.1783-5.998L19.7578,23.94a2.021,2.021,0,0,0,1.314-.1206L28,20.5811l-.8479-1.8121-6.9163,3.229L12.2422,20.06a2.0033,2.0033,0,0,0-1.74.3838L4,25.8818V20.49l7.7642-6.4877L19.7578,15.94a2.021,2.021,0,0,0,1.314-.1206l6.9287-3.2383-.8467-1.812-6.918,3.2285L12.2422,12.06a2.0049,2.0049,0,0,0-1.74.3838L4,17.8818V12.49L11.7642,6.002,19.7578,7.94a2.021,2.021,0,0,0,1.314-.1206L28,4.5859l-.8457-1.8115L20.2358,5.998,12.2422,4.06a2.0033,2.0033,0,0,0-1.74.3838L4,9.8818V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartMultiLine.propTypes = iconPropTypes;
}
const ChartMultitype = /*#__PURE__*/React.forwardRef(function ChartMultitype({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22H30V30H28z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18H26V30H24z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26H22V30H20z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M9,16a7,7,0,1,0,7,7A7.0078,7.0078,0,0,0,9,16Zm4.8989,6H10V18.1011A5.0145,5.0145,0,0,1,13.8989,22ZM9,28a5,5,0,0,1-1-9.8989V22a2,2,0,0,0,2,2h3.8989A5.0081,5.0081,0,0,1,9,28Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5352,12l4-6H30V4H25.4648l-4,6H18V2H16V14a2,2,0,0,0,2,2H30V14H18V12Z"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "7",
    r: "1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "11",
    r: "1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "5",
    r: "1"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "9",
    r: "1"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "13",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartMultitype.propTypes = iconPropTypes;
}
const ChartNetwork = /*#__PURE__*/React.forwardRef(function ChartNetwork({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2v4.1A5,5,0,0,0,18.1,22H14V20a2,2,0,0,0-2-2H10V13.9a5,5,0,1,0-2,0V18H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V24h4.1A5,5,0,1,0,24,18.1V14ZM6,9a3,3,0,1,1,3,3A3,3,0,0,1,6,9Zm6,17H6V20h6Zm14-3a3,3,0,1,1-3-3A3,3,0,0,1,26,23ZM20,6h6v6H20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartNetwork.propTypes = iconPropTypes;
}
const ChartParallel = /*#__PURE__*/React.forwardRef(function ChartParallel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2V5.3071l-6,2.25V2H20V7.5229l-8-3.2V2H10V4.4458l-6,3.75V2H2V30H4V27.6182l6-3V30h2V24.3442l8,2.4V30h2V26.5542l6-3.75V30h2V2Zm0,5.4429V12.5L22,17V9.6929ZM20,9.6768v7.5571l-8-4.8V6.4771ZM10,6.8042v5.7417l-6,5.25V10.5542ZM4,25.3818V20.4541l6-5.25v7.1777Zm8-3.1259v-7.49l8,4.8v5.0894Zm10,1.94V19.5L28,15v5.4458Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartParallel.propTypes = iconPropTypes;
}
const ChartPie = /*#__PURE__*/React.forwardRef(function ChartPie({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4ZM26,15H17V6.05A10,10,0,0,1,26,15ZM15.42,26A10,10,0,0,1,15,6.05v9a2,2,0,0,0,2,2h9A10,10,0,0,1,15.42,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartPie.propTypes = iconPropTypes;
}
const ChartPlanningWaterfall = /*#__PURE__*/React.forwardRef(function ChartPlanningWaterfall({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "m29,8c0-.5522-.4478-1-1-1h-4c-.5522,0-1,.4478-1,1v7h-2V3c0-.5522-.4478-1-1-1h-4c-.5522,0-1,.4478-1,1v12h-2V5c0-.5522-.4478-1-1-1h-4c-.5522,0-1,.4478-1,1v10H3v12c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-10h2v5c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-5h2v12c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-12h4v-9ZM7,26h-2v-9h2v9Zm8-5h-2v-4h2v4Zm2-6V4h2v11h-2Zm10,0h-2v-6h2v6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartPlanningWaterfall.propTypes = iconPropTypes;
}
const ChartPoint = /*#__PURE__*/React.forwardRef(function ChartPoint({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "3"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "22",
    r: "3"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "14",
    r: "3"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M9,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,9,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,9,13Z"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "27",
    cy: "6",
    r: "3"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "27",
    cy: "22",
    r: "3"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M27,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,27,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,27,13Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,18,26Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,18,22Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M18,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,18,8Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,18,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartPoint.propTypes = iconPropTypes;
}
const ChartPopulation = /*#__PURE__*/React.forwardRef(function ChartPopulation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M30,22H17V20h9V14H17V12h5V6H17V2H15V6H10v6h5v2H6v6h9v2H2v6H15v2h2V28H30ZM20,8v2H17V8Zm-8,2V8h3v2Zm12,6v2H17V16ZM8,18V16h7v2ZM4,26V24H15v2Zm24,0H17V24H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartPopulation.propTypes = iconPropTypes;
}
const ChartRadar = /*#__PURE__*/React.forwardRef(function ChartRadar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2,2,13,8,30H24l6-17Zm2.5818,19.2651-5.9861,1.3306-1.4226-7.8252,4.91-4.209,5.4416,4.0816Zm.1977,2.0054L21.3264,28H10.6736l1.7912-3.3267ZM9.59,13.4937,5.74,12.605,15,5.3291V8.8569ZM17,8.75V5.3291l9.26,7.2759-3.15.727ZM4.6143,14.3979l4.6535,1.0738,1.4844,8.164-1.738,3.2281ZM22.9858,26.8638l-2.5766-4.7852,3.0063-6.7646,3.97-.9161Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartRadar.propTypes = iconPropTypes;
}
const ChartRadial = /*#__PURE__*/React.forwardRef(function ChartRadial({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26A10.0115,10.0115,0,0,1,6,16H8a8,8,0,1,0,8-8V6a10,10,0,0,1,0,20Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6.0069,6.0069,0,0,1-6-6h2a4,4,0,1,0,4-4V10a6,6,0,0,1,0,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartRadial.propTypes = iconPropTypes;
}
const ChartRelationship = /*#__PURE__*/React.forwardRef(function ChartRelationship({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6a3.9963,3.9963,0,0,0-3.8579,3H17.9305A7.9964,7.9964,0,1,0,9,17.9307v4.2114a4,4,0,1,0,2,0V17.9307a7.951,7.951,0,0,0,3.8976-1.6192l3.6693,3.67A3.9529,3.9529,0,0,0,18,22a4,4,0,1,0,4-4,3.9521,3.9521,0,0,0-2.019.5669l-3.6694-3.6694A7.9493,7.9493,0,0,0,17.9305,11h4.2116A3.9934,3.9934,0,1,0,26,6ZM12,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,12,26ZM10,16a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,10,16Zm14,6a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,24,22Zm2-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartRelationship.propTypes = iconPropTypes;
}
const ChartRing = /*#__PURE__*/React.forwardRef(function ChartRing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9493,15.001H21.91a5.9825,5.9825,0,0,0-9.3806-3.8853l-4.27-4.27a11.9783,11.9783,0,0,1,19.69,8.1548ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20ZM4,16A11.937,11.937,0,0,1,6.8455,8.26l4.27,4.2695A5.9836,5.9836,0,0,0,15,21.9106v6.04A12.0105,12.0105,0,0,1,4,16ZM17,27.95v-6.04A6.0069,6.0069,0,0,0,21.91,17h6.04A12.0082,12.0082,0,0,1,17,27.95Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartRing.propTypes = iconPropTypes;
}
const ChartRiver = /*#__PURE__*/React.forwardRef(function ChartRiver({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4326,20.0171l8.0376,4.68a1.958,1.958,0,0,0,1.0508.3012,2.2412,2.2412,0,0,0,.4888-.0556l7.2532-1.9769A1,1,0,0,0,30,22.0007V7.996A1,1,0,0,0,28.74,7.0305L21.5034,8.9829l-8.0371-4.68a1.9917,1.9917,0,0,0-1.8652-.1352L4,7.4727V2H2V28a2,2,0,0,0,2,2H30V28H4V23.6577ZM28,21.2344l-6.4966,1.75-8.0371-4.68a1.9931,1.9931,0,0,0-1.8652-.1353L4,21.4746V16.6572l8.4326-3.6416L20.47,17.6968a1.962,1.962,0,0,0,1.0508.3008,2.2112,2.2112,0,0,0,.4888-.0557L28,16.31ZM12.4326,6.0156l8.0376,4.68a2.0091,2.0091,0,0,0,1.54.2451L28,9.3081v4.9258l-6.4966,1.7505-8.0371-4.6812a1.9917,1.9917,0,0,0-1.8652-.1352L4,14.4736V9.6562Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartRiver.propTypes = iconPropTypes;
}
const ChartRose = /*#__PURE__*/React.forwardRef(function ChartRose({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M30,17A15.017,15.017,0,0,0,15,2H14V8.0591A9.0122,9.0122,0,0,0,6.0591,16H4v1A11.0109,11.0109,0,0,0,14,27.9492V30h1A13.0084,13.0084,0,0,0,27.9492,18H30ZM16,4.0381A13.0217,13.0217,0,0,1,27.9619,16H16ZM14,10.08V16H8.08A7.0037,7.0037,0,0,1,14,10.08ZM6.0552,18H14v7.939A9.0134,9.0134,0,0,1,6.0552,18ZM16,27.9551V18h9.9551A11.0191,11.0191,0,0,1,16,27.9551Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartRose.propTypes = iconPropTypes;
}
const ChartScatter = /*#__PURE__*/React.forwardRef(function ChartScatter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "22",
    r: "2"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "15",
    r: "2"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "15",
    r: "2"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "6",
    r: "2"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "8",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartScatter.propTypes = iconPropTypes;
}
const ChartSpiral = /*#__PURE__*/React.forwardRef(function ChartSpiral({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartSpiral.propTypes = iconPropTypes;
}
const ChartStacked = /*#__PURE__*/React.forwardRef(function ChartStacked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartStacked.propTypes = iconPropTypes;
}
const ChartStepper = /*#__PURE__*/React.forwardRef(function ChartStepper({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartStepper.propTypes = iconPropTypes;
}
const ChartSunburst = /*#__PURE__*/React.forwardRef(function ChartSunburst({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartSunburst.propTypes = iconPropTypes;
}
const ChartTSne = /*#__PURE__*/React.forwardRef(function ChartTSne({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "20",
    r: "2"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "14",
    r: "2"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "4",
    r: "2"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "6",
    r: "2"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "10",
    r: "2"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "12",
    r: "2"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "22",
    r: "2"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "28",
    r: "2"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "26",
    r: "2"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "20",
    r: "2"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "4",
    r: "2"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "24",
    r: "2"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartTSne.propTypes = iconPropTypes;
}
const ChartTreemap = /*#__PURE__*/React.forwardRef(function ChartTreemap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartTreemap.propTypes = iconPropTypes;
}
const ChartVennDiagram = /*#__PURE__*/React.forwardRef(function ChartVennDiagram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartVennDiagram.propTypes = iconPropTypes;
}
const ChartViolinPlot = /*#__PURE__*/React.forwardRef(function ChartViolinPlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M14.86,7.8232,13,4.7231V2H11V4.7231l-1.86,3.1A7.9986,7.9986,0,0,0,8,11.939v.122a7.9961,7.9961,0,0,0,1.14,4.1158l1.86,3.1V26h2V19.2769l1.86-3.1A7.9986,7.9986,0,0,0,16,12.061v-.122A7.9961,7.9961,0,0,0,14.86,7.8232ZM12,6.9434l1.145,1.9087A6.0027,6.0027,0,0,1,13.9185,11h-3.837a6.0086,6.0086,0,0,1,.7735-2.1484Zm0,10.1132-1.145-1.9087A6.0027,6.0027,0,0,1,10.0815,13h3.837a6.0086,6.0086,0,0,1-.7735,2.1484Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M27.86,11.8232,26,8.7231V2H24V8.7231l-1.86,3.1A7.9986,7.9986,0,0,0,21,15.939v.122a7.9961,7.9961,0,0,0,1.14,4.1158l1.86,3.1V26h2V23.2769l1.86-3.1A7.9986,7.9986,0,0,0,29,16.061v-.122A7.9961,7.9961,0,0,0,27.86,11.8232Zm-2.86-.88,1.145,1.9087A6.0027,6.0027,0,0,1,26.9185,15h-3.837a6.0086,6.0086,0,0,1,.7735-2.1484Zm0,10.1132-1.145-1.9087A6.0027,6.0027,0,0,1,23.0815,17h3.837a6.0086,6.0086,0,0,1-.7735,2.1484Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartViolinPlot.propTypes = iconPropTypes;
}
const ChartWaterfall = /*#__PURE__*/React.forwardRef(function ChartWaterfall({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H16V18H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartWaterfall.propTypes = iconPropTypes;
}
const ChartWinLoss = /*#__PURE__*/React.forwardRef(function ChartWinLoss({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChartWinLoss.propTypes = iconPropTypes;
}
const Chat = /*#__PURE__*/React.forwardRef(function Chat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H24V12H8z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H18V18H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Chat.propTypes = iconPropTypes;
}

export { CalendarAddAlt, CalendarHeatMap, CalendarSettings, CalendarTools, Calibrate, Calls, CallsAll, CallsIncoming, Camera, CameraAction, Campsite, Car, CarFront, Carbon, CarbonAccounting, CarbonForAem, CarbonForIbmDotcom, CarbonForIbmProduct, CarbonForMobile, CarbonForSalesforce, CarbonUiBuilder, CaretDown, CaretLeft, CaretRight, CaretSort, CaretSortDown, CaretSortUp, CaretUp, CarouselHorizontal, CarouselVertical, Catalog, CatalogPublish, Categories, Category, CategoryAdd, CategoryAnd, CategoryNew, CategoryNewEach, Caution, CautionInverted, Cda, CellTower, CenterCircle, CenterSquare, CenterToFit, Certificate, CertificateCheck, ChangeCatalog, Channels, CharacterDecimal, CharacterFraction, CharacterInteger, CharacterLowerCase, CharacterNegativeNumber, CharacterPatterns, CharacterSentenceCase, CharacterUpperCase, CharacterWholeNumber, ChargingStation, ChargingStationFilled, ChartArea, ChartAreaSmooth, ChartAreaStepper, ChartAverage, ChartBar, ChartBarFloating, ChartBarOverlay, ChartBarStacked, ChartBarTarget, ChartBubble, ChartBubblePacked, ChartBullet, ChartCandlestick, ChartClusterBar, ChartColumn, ChartColumnFloating, ChartColumnTarget, ChartCombo, ChartComboStacked, ChartCustom, ChartDualYAxis, ChartErrorBar, ChartErrorBarAlt, ChartEvaluation, ChartHighLow, ChartHistogram, ChartLine, ChartLineData, ChartLineSmooth, ChartLogisticRegression, ChartMarimekko, ChartMaximum, ChartMedian, ChartMinimum, ChartMultiLine, ChartMultitype, ChartNetwork, ChartParallel, ChartPie, ChartPlanningWaterfall, ChartPoint, ChartPopulation, ChartRadar, ChartRadial, ChartRelationship, ChartRing, ChartRiver, ChartRose, ChartScatter, ChartSpiral, ChartStacked, ChartStepper, ChartSunburst, ChartTSne, ChartTreemap, ChartVennDiagram, ChartViolinPlot, ChartWaterfall, ChartWinLoss, Chart_3D, Chat, QCcX, WatsonHealthCdArchive, WatsonHealthCdCreateArchive, WatsonHealthCdCreateExchange };
